import {
    Box,
    Typography,
    Stack,
    Chip,
    AvatarGroup,
    Avatar,
    Tooltip,
} from "@mui/material"
import GroupIcon from "@mui/icons-material/Group"
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline"
import DescriptionIcon from "@mui/icons-material/Description"
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy"
import { CalendarMonth } from "@mui/icons-material"
import EventIcon from '@mui/icons-material/Event';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import StarIcon from '@mui/icons-material/Star';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SchoolIcon from '@mui/icons-material/School';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import InfoIcon from '@mui/icons-material/Info';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';


const TYPE_LABELS = {
    1: { label: "VR na żywo", icon: <CalendarMonthIcon fontSize="large" />, color: "#47be2f" },
    vr: { label: "Wydarzenie VR", icon: <SportsEsportsIcon fontSize="large" />, color: "#294e6b" },
    vr_special: { label: "Wydarzenie specjalne VR", icon: <StarIcon fontSize="large" />, color: "#1f3a57" },
    vr_seasonal: { label: "Wydarzenie sezonowe VR", icon: <EmojiEventsIcon fontSize="large" />, color: "#899cab" },
    training: { label: "Szkolenie", icon: <SchoolIcon fontSize="large" />, color: "#43babaff" },
    event: { label: "Wydarzenie", icon: <EventIcon fontSize="large" />, color: "#ff8235ff" },
    meeting: { label: "Spotkanie", icon: <MeetingRoomIcon fontSize="large" />, color: "#f59e0b" },
    information: { label: "Informacja", icon: <InfoIcon fontSize="large" />, color: "#8b5cf6" }
};




const CustomAgendaEvent = ({ event }) => {
    const { meta, players } = event


    const anonymizeEmail = (email = '') => {
        const local = email.split('@')[0];
        const firstPart = local.split(/[._-]/)[0];
        return `${firstPart}...`;
    };

    // console.log('eeevent', event)

    // console.log('meta.creator', meta.creator)

    return (
        <Box
            sx={{
                p: 0.75,
                my: 0.4,
                borderRadius: 1,
                backgroundColor: "rgba(255, 255, 255, 0.18)",
                boxShadow: 1,
                height: "100%",
                overflow: "hidden",
            }}
        >
            <Stack direction="row" spacing={0.5} alignItems="center">
                <CalendarMonth fontSize="small" sx={{ fontSize: 12 }} />
                <Typography
                    variant="subtitle2"
                    fontWeight={600}
                    noWrap
                    sx={{ fontSize: 12 }}
                >
                    {event.title} {meta.isVR && <SportsEsportsIcon sx={{ fontSize: 10, color: "#52eb34ff" }} />}
                </Typography>
            </Stack>


            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <TheaterComedyIcon fontSize="small" sx={{ fontSize: 12 }} />
                    <Typography variant="caption" noWrap sx={{ fontSize: 8 }}>
                        {meta.scenario}
                    </Typography>
                </Stack>

                <Stack direction="row" spacing={0.5} alignItems="center">
                    <GroupIcon fontSize="small" sx={{ fontSize: 12 }} />
                    <Typography variant="caption" sx={{ fontSize: 8 }}>
                        {meta.RequiredPlayersToStart}/{meta.MaxPlayers}
                        {players && players.length > 0 ? ` (${players.length})` : ''}
                    </Typography>
                    {/* <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", textAlign: "center" }}>
                        <Typography variant="caption" sx={{ fontSize: 8, margin: 0, padding: 0 }}>
                            {meta.RequiredPlayersToStart}/{meta.MaxPlayers}
                        </Typography>
                        <Typography variant="caption" sx={{ fontSize: 8, margin: 0, padding: 0 }}>
                            {players && players.length > 0 ? ` (${players.length})` : ''}
                        </Typography>
                    </Box> */}
                </Stack>
            </Box>





            {meta.description && (
                <>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <DescriptionIcon fontSize="small" sx={{ fontSize: 12 }} />
                        <Typography
                            variant="caption"
                            sx={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                fontSize: 8
                            }}
                        >
                            {meta.description}
                        </Typography>
                    </Stack>
                    <Box sx={{
                        // position: "absolute",
                        // right: 6,
                        // bottom: 8,
                        // color: "primary.main",
                        color: TYPE_LABELS[meta?.type]?.color ?? "primary.main",
                    }}
                    >{TYPE_LABELS[meta?.type]?.icon}</Box>
                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: 8,
                            fontStyle: "italic",
                            color: TYPE_LABELS[meta?.type]?.color ?? "primary.main",
                            // color: "secondary.contrastText",
                            // position: "absolute",
                            // bottom: 6,
                            // right: 6,
                        }}
                    >
                        {meta?.type
                            ? TYPE_LABELS[meta?.type]?.label ?? String(meta.type).charAt(0).toUpperCase() + String(meta.type).slice(1)
                            : "Unknown"}
                    </Typography>
                </>
            )}


            <AvatarGroup
                spacing="small"
                sx={{
                    justifyContent: "flex-end",
                    mt: 1,
                    '& .MuiAvatar-root': {
                        width: 24,
                        height: 24,
                        fontSize: 12,
                    },
                }}
            // renderSurplus={(surplus) => <span style={{ width: 24, height: 24 }}>+{surplus.toString()[0]}k</span>}
            // total={4251}
            >


                {meta?.participants?.map((participant) => (
                    <Tooltip title={participant.name} placement="top">
                        <Avatar
                            key={participant.id}
                            alt={anonymizeEmail(participant.name)}
                            src={participant.avatar}
                            sx={{ width: 24, height: 24, backgroundColor: "#1abc9c", boxShadow: "0 0 0 2px #1abc9c", }}
                        />
                    </Tooltip>
                ))}

                {players?.map((player) => (
                    <Tooltip title={player.name} placement="top">
                        <Avatar
                            key={player.id}
                            alt={anonymizeEmail(player.name)}
                            src={player.avatar}
                            sx={{ width: 24, height: 24, backgroundColor: "#4caf50", boxShadow: "0 0 0 2px #84e547ff", }}
                        />
                    </Tooltip>
                ))}

                {/* <Tooltip title={meta?.creator?.name} placement="top">
                    <Avatar
                        key={meta?.creator?.id}
                        alt={meta?.creator?.name}
                        src={meta?.creator?.avatar}
                        sx={{ width: 24, height: 24 }}
                    />
                </Tooltip> */}

                <Avatar alt="Remy Sharp" src="https://mui.com/static/images/avatar/1.jpg" sx={{ width: 24, height: 24 }} />
                <Avatar alt="Travis Howard" src="https://mui.com/static/images/avatar/2.jpg" sx={{ width: 24, height: 24 }} />
                {/* <Avatar alt="Agnes Walker" src="https://mui.com/static/images/avatar/4.jpg" sx={{ width: 24, height: 24 }} />
                <Avatar alt="Trevor Henderson" src="https://mui.com/static/images/avatar/5.jpg" sx={{ width: 24, height: 24 }} /> */}
            </AvatarGroup>
        </Box>
    )
}

export default CustomAgendaEvent;
